import React, { FunctionComponent } from 'react';

import ReactHTMLParser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldTitle.scss';

export const TemplateFieldTitle: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const { review } = context;

    if (!review?.activity_title) {
        return null;
    }

    const isTranslated = !!review.translated_title;
    const title = isTranslated ? review.translated_title : review.activity_title;

    return (
        <div className="r4e-review-template-field-title">
            <div className="r4e-review-title mb-2">
                {isTranslated ? `(${t('TRANSLATED_BY_REPUTATION')}) ` : ''}
                <span>{ReactHTMLParser(title!)}</span>
            </div>
            {isTranslated && (
                <div className="r4e-review-original-title">
                    ({t('ORIGINAL_TEXT')}) <span>{ReactHTMLParser(review.activity_title)}</span>
                </div>
            )}
        </div>
    );
};
